import {formatToDateString4} from 'app/format/date'
import React, {FC} from 'react'
import {lowerCase, capitalize} from 'lodash'

interface Props {
  isLast?: boolean
  title: string
  createdAt: string | any
  children?: React.ReactNode
  user: string
  userLabel?: string
  orderType?: string
}

export const HistoryItem: FC<Props> = ({
  isLast,
  title,
  createdAt,
  children,
  user,
  userLabel = 'Updated By',
  orderType,
}) => {
  return (
    <div className='d-flex flex-row align-items-start mb-2'>
      <div className='d-flex justify-content-between gap-2 align-items-start'>
        <div className='flex-column align-items-center justify-content-center pt-2'>
          <div className='dot border border-5 border-primary-active rounded mb-2' />
          {!isLast && <div className='border border-1 w-1px border-gray-400 h-55px ms-1' />}
        </div>
        <div className='d-flex flex-column w-100'>
          <span className='fw-bolder mt-1'>
            {title} {title === 'Order Created' && `via ${capitalize(lowerCase(orderType).trim())}`}
          </span>
          <span>{formatToDateString4(createdAt)}</span>
          {user && (
            <span className='mt-1'>
              {userLabel} : {user}
            </span>
          )}
          {children}
        </div>
      </div>
    </div>
  )
}

export default HistoryItem
